import Header from "../layout/Header";
import { HeaderBackground } from "../layout/Header";
import { AccentedText, IntroQuestionAside, Section } from "../layout/style";
import styled, { css } from "styled-components";


const LandingSlideContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
`;

const ColumnContainer = styled.div`
        // flex: 1 0 50%;
        // width: 50%;


`;

const RestyledSection = styled(Section)`

    & p {
        width: 80%;
    }

`;

const LandingSlide = () => {

    return <>
        <LandingSlideContainer>
            <HeaderBackground />
            <Header />
            <IntroQuestionAside>How can the kinesthetic dimensions of <b>physical interaction</b> be made <b>visible</b>?</IntroQuestionAside>
            <RestyledSection>
                <p>This is one of the key questions that motivate the work behind <i>Proxies</i>, a dance theatre production and creative research project in development with choreography by Ilya Vidrin and data visualization by Steven Geofrey. Interweaving dance, music, and computational design, the production considers what aspects of embodied experience can and cannot be captured through wearable technology. At the same time, <i>Proxies</i> investigates the role that technology and design might be used to return attention to <strong>kinesthetic experience</strong> (internal experience of movement) within our own bodies – using technology to prime awareness of movement, rather than strictly datafy and represent biomechanics.
                </p>
                <p><AccentedText>Touch the navigation on the bottom of the screen to move to the next slide and keep reading.</AccentedText></p>
            </RestyledSection>
        </LandingSlideContainer>
    </>;

}

export default LandingSlide;